import { initSmoothScroll } from "./modules/smoothScroll.js";
import { initMenu } from "./modules/menu.js";
import { initNav } from "./modules/nav.js";
import { initAccordion } from "./modules/accordion.js";
import { initSchema } from "./modules/schema.js";
import { initCarousel } from "./modules/carousel.js";
import { initParallax } from "./modules/parallax.js";
import { initReveal } from "./modules/reveal.js";
import { initModal } from "./modules/modal.js";

const init = () => {
  document.documentElement.classList.add("has-js");
  initSmoothScroll(); // en premier : pilote le scroll avant que parallax/nav s'attachent
  initMenu();
  initNav();
  initAccordion();
  initSchema();
  initCarousel();
  initParallax();
  initReveal();
  initModal();
};

if (document.readyState !== "loading") {
  init();
} else {
  document.addEventListener("DOMContentLoaded", init);
}
